// frontend/modules/sms/views/SmsManagementView.tsx
import React from 'react';
import { Typography, Tabs, Card, Row, Col } from 'antd';
import { MessageOutlined, UnorderedListOutlined, RobotOutlined } from '@ant-design/icons';
import SmsForm from '../components/SmsForm';
import SmsBalanceCard from '../components/SmsBalanceCard';
import FakerSmsLogsTable from '../components/FakerSmsLogsTable';
import { useTheme } from '@/components/common/ThemeProvider';
import { useSms } from '../hooks/useSms';

const { Title } = Typography;

const SmsManagementView: React.FC = () => {
    const { dark } = useTheme();
    const {
        smsBalance,
        isLoadingBalance,
        loadSmsBalance,
        fakerLogs,
        fakerLogsPage,
        fakerLogsPageSize,
        fakerLogsTotalElements,
        isLoadingFakerLogs,
        refreshFakerLogs,
        onFakerLogsPageChange,
        clearFakerLogs,
        isClearingLogs,
    } = useSms();

    const tabItems = [
        {
            key: 'send',
            label: (
                <span>
                    <MessageOutlined className="mr-1" />
                    Send SMS
                </span>
            ),
            children: <SmsForm />,
        },
        {
            key: 'faker-logs',
            label: (
                <span>
                    <RobotOutlined className="mr-1" />
                    Faker SMS Logs
                </span>
            ),
            children: (
                <Card className={dark ? 'bg-gray-800 text-white' : ''}>
                    <FakerSmsLogsTable
                        data={fakerLogs}
                        loading={isLoadingFakerLogs}
                        pagination={{
                            current: fakerLogsPage + 1, // antd is 1-based
                            pageSize: fakerLogsPageSize,
                            total: fakerLogsTotalElements,
                            onChange: onFakerLogsPageChange,
                        }}
                        onRefresh={refreshFakerLogs}
                        onClearLogs={clearFakerLogs}
                        clearingLogs={isClearingLogs}
                    />
                </Card>
            ),
        },
    ];

    return (
        <div className="space-y-6">
            {/* Header */}
            <Card className={dark ? 'bg-gray-800 text-white' : ''}>
                <Title level={4} className={dark ? 'text-white' : ''}>
                    SMS Management
                </Title>
                <Typography.Paragraph className={dark ? 'text-gray-300' : ''}>
                    Send SMS messages to your customers and monitor your SMS balance.
                </Typography.Paragraph>
            </Card>

            {/* Balance banner */}
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12} lg={8}>
                    <SmsBalanceCard
                        balance={smsBalance}
                        isLoading={isLoadingBalance}
                        onRefresh={loadSmsBalance}
                    />
                </Col>
            </Row>

            {/* Tabs */}
            <Tabs
                defaultActiveKey="send"
                className={dark ? 'text-white' : ''}
                items={tabItems}
            />
        </div>
    );
};

export default SmsManagementView;